import { HTMLFromRichText, TextFromRichText } from './PrismicTypes';

export const CONTENT_HERO_IMAGE = 'PrismicGenericTemplateDataBodyContentPageHero';

export interface ContentHeroImagePrimary {
  hero_image_subtitle: HTMLFromRichText;
  hero_image_title: TextFromRichText;
  hero_image_variant: 'white' | 'blue' | 'mint' | 'grey';
  hide_breadcrumbs?: boolean;
  is_full_width?: boolean;
}

export interface ContentHeroImageContent {
  __typename: typeof CONTENT_HERO_IMAGE;
  primary: ContentHeroImagePrimary;
}
